import SpeedDial, {SpeedDialProps} from '@mui/material/SpeedDial';
import SpeedDialAction, {SpeedDialActionProps} from '@mui/material/SpeedDialAction';
import SpeedDialIcon, {SpeedDialIconProps} from '@mui/material/SpeedDialIcon';

import {styled} from '@mui/material/styles';

export const CSpeedDial = styled(SpeedDial)<SpeedDialProps>(
  (/* { theme } */) => ({
  }),
);

export const CSpeedDialAction = styled(SpeedDialAction)<SpeedDialActionProps>(
  (/* { theme } */) => ({
  }),
);

export const CSpeedDialIcon = styled(SpeedDialIcon)<SpeedDialIconProps>(
  (/* { theme } */) => ({
  }),
);
